export enum StateStatus {
    PENDING = 0,
    FULFILLED = 1,
    REJECTED = 2,
}
